import { ReactNode, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { App as CapacitorApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import {
  auth0CallbackUrl,
  auth0Domain,
  isNativeApp,
} from "../../shared/runtime";

function NativeAuthCallback(props: { children: ReactNode }) {
  const { handleRedirectCallback } = useAuth0();

  useEffect(() => {
    if (!isNativeApp) {
      return;
    }

    let disposed = false;
    let removeListener: (() => Promise<void>) | undefined;

    CapacitorApp.addListener("appUrlOpen", async ({ url }) => {
      if (
        url.includes("/capacitor/") &&
        url.includes("state=") &&
        (url.includes("code=") || url.includes("error="))
      ) {
        await handleRedirectCallback(url);
      }
      await Browser.close();
    }).then((listener) => {
      if (disposed) {
        listener.remove();
      } else {
        removeListener = () => listener.remove();
      }
    });

    return () => {
      disposed = true;
      removeListener?.();
    };
  }, [handleRedirectCallback]);

  return <>{props.children}</>;
}

const Auth0ProviderWithHistory = (props:{ children:  ReactNode}) => {
  const domain = auth0Domain();
  const clientId = process.env.NODE_ENV==="production"?process.env.REACT_APP_AUTH0_CLIENT_ID_PROD:process.env.REACT_APP_AUTH0_CLIENT_ID_DEV;
  const history = useHistory();

  const onRedirectCallback = (appState:any) => {
   
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain as unknown as string}
      clientId={clientId as unknown as string}
      authorizationParams={{
        audience: "rank5.io",
        scope: "read:current_user update:current_user_metadata",
        redirect_uri: isNativeApp
          ? auth0CallbackUrl(domain)
          : window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      skipRedirectCallback={isNativeApp}
    >
      <NativeAuthCallback>{props.children}</NativeAuthCallback>
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
